import './Board.css';

function Board(props) {
  let gridStyle = {
    gridTemplateColumns: `repeat(${Math.sqrt(props.children.length).toPrecision(1)}, 1fr)`
  };

  return (
    <div className="board" style={gridStyle}>
      {props.children}
    </div>
  );
}

export default Board;